import { gql } from '@apollo/client';

export const CREATE_EXTERNAL_PAYMENT = gql`
  mutation CreateExternalPayment($input: ExternalPaymentInput!) {
    createExternalPayment(input: $input) {
      transactionId
      paymentUrl
    }
  }
`;
